module.exports = {
  local: {
    '1': {
      company: 'Maven Machines',
      companyId: 1,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
    '43': {
      company: 'Pitt Ohio',
      companyId: 43,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
  },
  development: {
    '1': {
      company: 'Maven Machines',
      companyId: 1,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
    '43': {
      company: 'Pitt Ohio',
      companyId: 43,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
  },
  qa: {
    '1': {
      company: 'Maven Machines',
      companyId: 1,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
    '43': {
      company: 'Pitt Ohio',
      companyId: 43,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
  },
  staging: {
    '1': {
      company: 'Maven Machines',
      companyId: 1,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
    '43': {
      company: 'Pitt Ohio',
      companyId: 43,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
  },
  preprod: {
    '1': {
      company: 'Maven Machines',
      companyId: 1,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
    '43': {
      company: 'Pitt Ohio',
      companyId: 43,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
  },
  production: {
    '1': {
      company: 'Maven Machines',
      companyId: 1,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
    '410': {
      company: 'Pitt Ohio',
      companyId: 410,
      messagesOptions: {
        hideOldMessages: true,
      },
    },
  },
};
